import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { MediaService } from '../../services/media/MediaService';
import { AudioDeviceButton, VideoDeviceButton } from '../DeviceButton';
import { selectCamera } from '../popups/devices/CameraSelectorPopup';
import { selectMicrophone } from '../popups/devices/MicrophoneSelectorPopup';
import { ShareScreenButton } from './helpers/ShareScreenButton';
import { ToggleLiveButton } from './helpers/ToggleLiveButton';
export function BroadcasterFooter() {
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const mediaService = MediaService.getNotificationInterface();
    const mediaOutputMediaStreamData = MediaService.getOutput().useMediaStreamData();
    const mediaOutputAudioMuted = MediaService.getOutput().useAudioMuted();
    const mediaOutputVideoMuted = MediaService.getOutput().useVideoMuted();
    const connectedVideoDevices = MediaService.getOutput().useVideoDevices();
    const connectedAudioDevices = MediaService.getOutput().useAudioDevices();
    const onMuteAudioButtonClicked = () => {
        if (mediaOutputAudioMuted) {
            mediaService.notifyAudioMutingChangeRequested(false);
        }
        else {
            mediaService.notifyAudioMutingChangeRequested(true);
        }
    };
    const onMuteVideoButtonClicked = () => {
        if (mediaOutputVideoMuted) {
            mediaService.notifyVideoMutingChangeRequested(false);
        }
        else {
            mediaService.notifyVideoMutingChangeRequested(true);
        }
    };
    const broadcastTitle = (_jsxs(BroadcastTitle, { children: ["\u200C", activeBroadcast.name] }));
    const toggleBroadcastButton = (_jsx(ToggleLiveButtonWrap, { children: _jsx(ToggleLiveButton, { device: "desktop", disabled: !mediaOutputMediaStreamData.mediaStream.active }) }));
    return (_jsxs(BroadcasterFooterRoot, { children: [_jsxs(Segment0, { children: [broadcastTitle, toggleBroadcastButton] }), _jsxs(Segment1, { children: [broadcastTitle, _jsx(AudioDeviceButton, { devicePresent: connectedAudioDevices.length > 0, muted: mediaOutputAudioMuted ||
                            mediaOutputMediaStreamData.isSharingScreenAudio, onMuteClick: onMuteAudioButtonClicked, onSelectClick: (anchor) => {
                            selectMicrophone({
                                anchorRef: anchor,
                                variant: 'top-center',
                            });
                        } }), _jsx(VideoDeviceButton, { devicePresent: connectedVideoDevices.length > 0, muted: mediaOutputVideoMuted ||
                            mediaOutputMediaStreamData.isSharingScreenVideo, onMuteClick: onMuteVideoButtonClicked, onSelectClick: (anchor) => {
                            selectCamera({
                                anchorRef: anchor,
                                variant: 'top-center',
                            });
                        } }), _jsx(ShareScreenButtonWrap, { children: _jsx(ShareScreenButton, {}) }), toggleBroadcastButton] })] }));
}
const ShareScreenButtonWrap = styled.div `
    display: var(--ShareScreenButton_Display, block);
`;
const ToggleLiveButtonWrap = styled.div `
    display: var(--ToggleLiveButton_Display, block);
`;
const BroadcastTitle = styled.div `
    display: var(--BroadcastTitle_Display, block);
    font-weight: 700;
    font-size: 18px;
    line-height: 18px;
    letter-spacing: 0%;
    color: #ffffff;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
`;
const Segment0 = styled.div `
    align-items: center;
    display: var(--Segment0_Display, grid);
    gap: 1rem;
    grid-template-columns: 1fr auto;
    margin-bottom: 1rem;
`;
const Segment1 = styled.div `
    --BroadcastTitle_Display: none;
    --ShareScreenButton_Display: none;
    --ToggleLiveButton_Display: none;

    align-items: center;
    display: flex;
    justify-content: space-between;

    @media (min-width: 25rem) {
        --ShareScreenButton_Display: initial;
    }

    @media (min-width: 48rem) {
        --BroadcastTitle_Display: initial;
        --ToggleLiveButton_Display: initial;

        display: grid;
        grid-template-columns: 1fr auto auto auto auto 1fr;
        gap: 1rem;
        justify-content: initial;
    }
`;
const BroadcasterFooterRoot = styled.div `
    overflow: hidden;
    padding: 1.5rem;

    @media (min-width: 48rem) {
        --Segment0_Display: none;
    }
`;
